import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`

export const TuneIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M10.6667 23.9993V16.666H12.6667V19.3327H23.3333V21.3327H12.6667V23.9993H10.6667ZM0 21.3327V19.3327H7.33333V21.3327H0ZM5.33333 15.9993V13.3327H0V11.3327H5.33333V8.66602H7.33333V15.9993H5.33333ZM10.6667 13.3327V11.3327H23.3333V13.3327H10.6667ZM16 7.99935V0.666016H18V3.33268H23.3333V5.33268H18V7.99935H16ZM0 5.33268V3.33268H12.6667V5.33268H0Z" />
    </Svg>
  )
}
